import axios from 'axios';

const API_BASE_URL = 'https://api.nagaanalytics.com';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor for better error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const authAPI = {
    
    login: (email, password) => {
        const formData = new FormData();
        formData.append('username', email);  // FastAPI OAuth2 expects 'username'
        formData.append('password', password);
        return api.post('/api/auth/login', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    
    register: (userData) => api.post('/api/auth/register', userData),
    
    verifyEmail: (token) => api.get(`/api/auth/verify-email?token=${token}`),

    validateUser: () => api.get('/api/auth/validate'),    
    
    getCurrentUser: () => api.get('/api/auth/me'),
};

export default api;
